export const isModifierClick = (
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
) => {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
  );
};
